function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'7a5b2342133a0cfbb741f672ea2ec5e3': 'rgb(0, 0, 128)','6f4ec514eee84cc58c8e610a0c87d7a2': 'rgb(176, 101, 0)','6ff47afa5dc7daa42cc705a03fca8a9b': 'rgb(139, 69, 19)','09895ea76baa9f58127457d34bc96e52': 'rgb(165, 42, 42)','a8bba0ac9999dbc8c61175fc03f5b6d7': 'rgb(128, 0, 32)','6ac17b0c2dbe6ea9d317bccf3e230ae1': 'rgb(189, 86, 32)','0897049c25d918c84ce3643273765f79': 'rgb(50, 120, 188)','4b3311220354b375e0610f39107a602e': 'rgb(0, 0, 128)','d0353bee6ee1cd9b3ebc72c434683a79': 'rgb(176, 101, 0)','58ce60edadaaa15ef366f88b7286e33f': 'rgb(139, 69, 19)','4a327ff5a1347d0673a9645033d7d854': 'rgb(165, 42, 42)','842c3ed32826df4c23176c98dbf26b81': 'rgb(128, 0, 32)','a9fd85f3ef577a3141c46f488d0eed15': 'rgb(189, 86, 32)','38b593f7cca0e7dc818d7c539b69e454': 'rgb(50, 120, 188)','171dbf9c0739f89183cabd615b11f56e': 'rgb(245, 245, 220)','74c02bab6e483c44a18c2bb1d56c1d72': 'rgb(128, 128, 0)','685588e03881f69d56b28b65aa2e6aa3': 'rgb(255, 165, 0)','07dc94a2026a0e2c8f5477404e8d43ff': 'rgb(0, 0, 0)','907ebb84ccb6822cbb51cca1ba7c1a59': 'rgb(128, 128, 128)','9ca1af4d4bc551a02d939f831cf9df4b': 'rgb(0, 0, 128)','07b508e096066ec1ce121a662aeadccc': 'rgb(176, 101, 0)','d9a85010429a28488ce8b4c907c9ec02': 'rgb(139, 69, 19)','acd7d8e6fc554d61ce8118cb5a739ccb': 'rgb(165, 42, 42)','eead3fbfae73c258627c7ea51e8d4a73': 'rgb(128, 0, 32)','c4ff2edf060c649a91cb7c7ad8b5f143': 'rgb(189, 86, 32)','eaa087d75214ce1aeeb76fa02ff7fc4c': 'rgb(50, 120, 188)','b59f8f3854abf10b87093d912a936377': 'rgb(0, 0, 0)','f431b0eea3c08186ed101e588bfb3a2f': 'rgb(128, 128, 0)','efc5f4b470619b932aed03953e50ce60': 'rgb(245, 245, 220)','4d9ad661c53222023932665b4a2a4f6d': 'rgb(128, 128, 128)','091808fcfe95ad6473dec65aedd05e90': 'rgb(255, 165, 0)','c0579360b4056c8faa57b4d52be40149': 'rgb(128, 128, 0)','09cb4366ae45130079d403705efcbac4': 'rgb(0, 0, 128)','3e6aeca1e7cb0885fa0b03d0b80c7ab9': 'rgb(176, 101, 0)','33b1929f4a9a34b0cc0274860e07096a': 'rgb(139, 69, 19)','3e6aeca1e7cb0885fa0b03d0b80c7ab9': 'rgb(165, 42, 42)','4f373cadf11b6d3d323f77b1e3de1fa5': 'rgb(128, 0, 32)','f4859e2d9887fb2313df726bd84e1756': 'rgb(189, 86, 32)','5fce29d1c655a45248594ab126629369': 'rgb(50, 120, 188)','3d17514e3da75d06bf5ccaed068ba7da': 'rgb(0, 0, 0)','af0c3ad1aaaac0a6d0b26e29de113248': 'rgb(128, 128, 0)','fe01d67a002dfa0f3ac084298142eccd': 'rgb(255, 165, 0)','9d56f8d5611bc53fa1b652cb83345e21': 'rgb(128, 128, 128)','efc5f4b470619b932aed03953e50ce60': 'rgb(245, 245, 220)','b329f324cc17d6221a385ea1afb3a289': 'rgb(46, 41, 78)','b4de9a64b84a3773fefa37110fcd094e': 'rgb(50, 120, 188)','cd0ef04aab8b7d7c3dac55f182b5ad8a': 'rgb(176, 101, 0)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
